import { AllSupervisorWithLocationEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import { strongSupport, weakSupport, weakOppose, strongOppose } from "../../../../src/utils/pulsePalette.js";
import DoughnutWrapper from "../../../../src/components/pulse/doughnutWrapper";
import CrossTabChart from "../../../../src/components/pulse/CrossTabChart";
import * as React from 'react';
export default {
  AllSupervisorWithLocationEmailCTA,
  strongSupport,
  weakSupport,
  weakOppose,
  strongOppose,
  DoughnutWrapper,
  CrossTabChart,
  React
};